var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1ProjectionScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 49V15H40v-3a2 2 0 00-4 0v3H15v34h21v5.08l-8.3 7.06a2 2 0 002.6 3l5.7-4.81V63a2 2 0 004 0v-3.67l5.7 4.86a2 2 0 001.3.48 2 2 0 001.52-.67 2 2 0 00-.22-2.82l-8.3-7.1V49h21zm-42-4V19h38v26H19zm25.47-17.7a7.93 7.93 0 011.41 6.13A8 8 0 1138 24v8l6.47-4.7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Projection_screen.faf51d5a.svg";
export { SvgH1ProjectionScreen as ReactComponent };